import {
  SUBMIT_COLLECTION_REQUEST,
  SUBMIT_COLLECTION_SUCCESS,
  SUBMIT_COLLECTION_FAIL,
  SUBMIT_COLLECTION_RESET,
  GET_MY_COLLECTIONS_REQUEST,
  GET_MY_COLLECTIONS_SUCCESS,
  GET_MY_COLLECTIONS_FAIL,
  GET_MY_COLLECTIONS_RESET,
  GET_MY_PROCESSES_REQUEST,
  GET_MY_PROCESSES_SUCCESS,
  GET_MY_PROCESSES_FAIL,
  GET_MY_PROCESSES_RESET,
  GET_MY_STATISTICS_REQUEST,
  GET_MY_STATISTICS_SUCCESS,
  GET_MY_STATISTICS_FAIL,
  GET_MY_STATISTICS_RESET,
  UPDATE_COLLECTION_REQUEST,
  UPDATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION_FAIL,
  UPDATE_COLLECTION_RESET,
  DELETE_COLLECTION_REQUEST,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAIL,
  DELETE_COLLECTION_RESET,
  GET_PROCESS_DEFAULTS_REQUEST,    // Add this
  GET_PROCESS_DEFAULTS_SUCCESS,    // Add this
  GET_PROCESS_DEFAULTS_FAIL,       // Add this
  GET_PROCESS_DEFAULTS_RESET,
} from '../constants/dailyCollectionConstants'

export const submitCollectionReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBMIT_COLLECTION_REQUEST:
      return { loadingSubmitCollection: true }
    case SUBMIT_COLLECTION_SUCCESS:
      return {
        loadingSubmitCollection: false,
        submitCollectionData: action.payload,
      }
    case SUBMIT_COLLECTION_FAIL:
      return {
        loadingSubmitCollection: false,
        errorSubmitCollection: action.payload,
      }
    case SUBMIT_COLLECTION_RESET:
      return {}
    default:
      return state
  }
}

export const getMyCollectionsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MY_COLLECTIONS_REQUEST:
      return { loadingMyCollections: true }
    case GET_MY_COLLECTIONS_SUCCESS:
      return {
        loadingMyCollections: false,
        myCollectionsData: action.payload,
      }
    case GET_MY_COLLECTIONS_FAIL:
      return {
        loadingMyCollections: false,
        errorMyCollections: action.payload,
      }
    case GET_MY_COLLECTIONS_RESET:
      return {}
    default:
      return state
  }
}

export const getMyProcessesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MY_PROCESSES_REQUEST:
      return { loadingMyProcesses: true }
    case GET_MY_PROCESSES_SUCCESS:
      return {
        loadingMyProcesses: false,
        myProcessesData: action.payload,
      }
    case GET_MY_PROCESSES_FAIL:
      return {
        loadingMyProcesses: false,
        errorMyProcesses: action.payload,
      }
    case GET_MY_PROCESSES_RESET:
      return {}
    default:
      return state
  }
}

export const getMyStatisticsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MY_STATISTICS_REQUEST:
      return { loadingMyStatistics: true }
    case GET_MY_STATISTICS_SUCCESS:
      return {
        loadingMyStatistics: false,
        myStatisticsData: action.payload,
      }
    case GET_MY_STATISTICS_FAIL:
      return {
        loadingMyStatistics: false,
        errorMyStatistics: action.payload,
      }
    case GET_MY_STATISTICS_RESET:
      return {}
    default:
      return state
  }
}

export const updateCollectionReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_COLLECTION_REQUEST:
      return { loadingUpdateCollection: true }
    case UPDATE_COLLECTION_SUCCESS:
      return {
        loadingUpdateCollection: false,
        updateCollectionData: action.payload,
      }
    case UPDATE_COLLECTION_FAIL:
      return {
        loadingUpdateCollection: false,
        errorUpdateCollection: action.payload,
      }
    case UPDATE_COLLECTION_RESET:
      return {}
    default:
      return state
  }
}

export const deleteCollectionReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_COLLECTION_REQUEST:
      return { loadingDeleteCollection: true }
    case DELETE_COLLECTION_SUCCESS:
      return {
        loadingDeleteCollection: false,
        deleteCollectionData: action.payload,
      }
    case DELETE_COLLECTION_FAIL:
      return {
        loadingDeleteCollection: false,
        errorDeleteCollection: action.payload,
      }
    case DELETE_COLLECTION_RESET:
      return {}
    default:
      return state
  }
}


export const getProcessDefaultsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PROCESS_DEFAULTS_REQUEST:
      return { loadingProcessDefaults: true };
    case GET_PROCESS_DEFAULTS_SUCCESS:
      return { loadingProcessDefaults: false, processDefaultsData: action.payload };
    case GET_PROCESS_DEFAULTS_FAIL:
      return { loadingProcessDefaults: false, errorProcessDefaults: action.payload };
    case GET_PROCESS_DEFAULTS_RESET:
      return {};
    default:
      return state;
  }
};